import React, { useEffect, useState } from "react";
import Tilt from "react-parallax-tilt";
import { motion } from "framer-motion";

const Slider = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const importImages = async () => {
      const imageContext = require.context(
        "./SliderAssets",
        false,
        /\.(png|jpe?g|svg)$/
      );
      const imagePaths = imageContext.keys().map(imageContext);
      setImages(imagePaths);
    };

    importImages();
  }, []);

  return (
    <div className="flex w-full items-center justify-center">
      <div className="w-full h-24 overflow-hidden relative">
        <motion.div
          className="w-[500%] animate flex items-center h-16 border-b-2 bg-gray-100 bg-opacity-80 border-t-2 py-2 justify-around absolute top-3 left-0 gap-7"
          initial={{ x: "-100%" }}
          animate={{ x: "0" }}
          transition={{ duration: 0.5 }}
        >
          {images.map((i, index) => (
            <motion.img
              key={index}
              src={i}
              className="h-full "
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.2, duration: 0.5 }}
            />
          ))}
          {images.map((i, index) => (
            <motion.img
              key={index}
              src={i}
              className="h-full "
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 3.8 + index * 0.2 , duration: 0.5 }}
            />
          ))}
          {images.map((i, index) => (
            <motion.img
              key={index}
              src={i}
              className="h-full "
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 7.6 + index * 0.2, duration: 0.5 }}
            />
          ))}
          {images.map((i, index) => (
            <motion.img
              key={index}
              src={i}
              className="h-full "
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 11.4 + index * 0.2, duration: 0.5 }}
            />
          ))}
          {images.map((i, index) => (
            <motion.img
              key={index}
              src={i}
              className="h-full "
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 15.2 + index * 0.2, duration: 0.5 }}
            />
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Slider;
